// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__byfZC","productName":"Table_productName__VZLeR"};